import { Component, Input, OnInit } from '@angular/core';
import { FirebaseService } from "../../providers/firebase.service";
import { Hour } from "../../models/hour";

@Component({
  selector: 'scs-gate-hours',
  templateUrl: './gate-hours.component.html',
  styleUrls: ['./gate-hours.component.css']
})
export class GateHoursComponent implements OnInit {
  @Input() clientData;
  @Input() gateHours;
  @Input() locationKey;

  gateHour: Hour;
  selectedGateHour: Hour;
  displayGateHourDialog: boolean;
  newGateHour: boolean;

  constructor(public afService: FirebaseService) { }

  ngOnInit() {
  }

  showGateHourDialogToAdd() {
    this.newGateHour = true;
    this.gateHour = new Hour();
    this.displayGateHourDialog = true;
  }

  onGateHourRowSelect(event) {
    this.newGateHour = false;
    this.gateHour = event.data;
    this.displayGateHourDialog = true;
  }

  saveGateHour() {
    console.log(this.gateHour);
    if (this.newGateHour == true) {
      this.afService.saveGateHour(this.gateHour, this.clientData.$key, this.locationKey).then(() => {
        this.afService.openSnackBar('Gate Hour successfully created.');
      });
    }
    else {
      this.afService.updateGateHour(this.gateHour, this.clientData.$key, this.locationKey).then(() => {
        this.afService.openSnackBar('Gate Hour successfully updated.');
      }).catch(e => {
        this.afService.openSnackBar(e.message);
      });
    }

    this.gateHour = null;
    this.displayGateHourDialog = false;
  }

  deleteGateHour() {
    console.log(this.gateHour);
    this.afService.deleteGateHour(this.gateHour, this.clientData.$key, this.locationKey).then(() => {
      this.afService.openSnackBar('Gate Hour successfully Deleted.');
    }).catch(e => {
      this.afService.openSnackBar(e.message);
    });
    this.selectedGateHour = null;
    this.displayGateHourDialog = false;
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/components/gate-hours/gate-hours.component.ts